import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ProjectsService } from '../../../../../../../../core/projects.service';
import { ProjectDetailsService } from '../../../../project-details.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { DeleteActivityIdsDetailsRequest, UpdateActivityIdsDetailsRequest } from '../../../../../../../../core/projects.actions';

@Component({
    selector: 'app-activity-id-details',
    templateUrl: './activity-id-details.component.html',
    styleUrls: ['./activity-id-details.component.scss'],
    standalone: false
})
export class ActivityIdDetailsComponent implements OnInit, OnDestroy {
  @Input() data: any;
  form = this.fb.group<any>({
    activityId: new FormControl({ value: null, disabled: false }),
    name: new FormControl({ value: null, disabled: false }),
    segment: new FormControl({ value: null, disabled: false }),
    location: new FormControl({ value: null, disabled: false }),
  });
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private fb: FormBuilder,
    private store: Store<fromRoot.State>,
    private projectsService: ProjectsService,
    private projectDetailsService: ProjectDetailsService,
  ) {
  }

  ngOnInit() {
    if (this.data) {
      this.form.patchValue({
        activityId: this.data.activity_id,
        name: this.data.name,
        segment: this.data.segment,
        location: this.data.location,
      }, { emitEvent: false });
    }

    this.form.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.projectsService.isAnyFormDirty.next(true);
      });

    this.projectDetailsService.triggerSave
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.save();
      });

    this.projectDetailsService.triggerDelete
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.delete();
      });
  }


  save() {
    const { activityId, name, segment, location } = this.form.getRawValue();
    const payload = {
      activity_id: activityId,
      name,
      segment,
      location,
      id: this.data.id,
      projectId: this.data.projectId,
    };

    this.store.dispatch(UpdateActivityIdsDetailsRequest({ payload }));
  }

  delete() {
    const payload = {
      id: this.data.id,
      projectId: this.data.projectId,
    };

    this.store.dispatch(DeleteActivityIdsDetailsRequest({ payload }));
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
